module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "weight-input"
    }
  }, [_c('mu-card-text', {
    staticClass: "card-style",
    class: {
      cardHasData: _vm.hasData
    }
  }, [(_vm.loading) ? _c('div', [_c('mu-flexbox', {
    staticClass: "card-loading-padding",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 60,
      "color": "#FFFFFF",
      "strokeWidth": 5
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [(_vm.data.no_setting || _vm.data.error) ? _c('mu-flexbox', {
    staticClass: "card-error-padding",
    attrs: {
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "card-notice-title",
    domProps: {
      "textContent": _vm._s(_vm.data.no_height_setting ? _vm.$t('message.cardWeightEmptyHeight') : _vm.$t('message.cardEmpty'))
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.cardTapPrefix')) + "\n            "), (_vm.data.no_setting) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "settings"
    },
    slot: "left"
  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.$t('message.cardTapSuffix')) + "\n\n          ")], 1)])], 1) : _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goToDetail
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.hasData = true))]), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardLatestReading'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "card-large-stat"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.data.latest)
    }
  }), _vm._v(" "), (_vm.data.userDevice && _vm.data.userDevice.userDeviceId !== 0) ? _c('span', [_c('img', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: (_vm.t('message.cardFromDevice') + ' ' + _vm.data.userDevice.nickname),
      expression: "t('message.cardFromDevice') + ' ' +  data.userDevice.nickname",
      modifiers: {
        "left": true
      }
    }],
    staticStyle: {
      "position": "relative",
      "top": "6px",
      "margin-left": "4px"
    },
    attrs: {
      "width": "22",
      "src": _vm.data.userDevice.device.iconWhite
    }
  })]) : _vm._e()])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.data.lost_weight ? _vm.$t('message.cardWeightTotalLoss') : _vm.$t('message.cardWeightTotalGain'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.difference)
    }
  })])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.data.week_weight.lost_weight ? _vm.$t('message.cardWeightLostThisWeek') : _vm.$t('message.cardWeightGainedThisWeek'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.week_weight.difference)
    }
  })])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardWeightWaistHipRatio'))
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.waist_hip_ratio)
    }
  })])], 1)], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('mu-card-actions', [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "16px",
      "height": "14px",
      "viewBox": "0 3 16 14",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.0274359,4.84740771 C14.8735715,3.69796239 14.1860505,3 13.1481453,3 L7.99995032,3 L2.85178845,3 C1.81394954,3 1.12642845,3.69796239 0.972531032,4.84740771 C0.81863361,5.99685303 0,14.2824828 0,14.2824828 C0,15.3027795 0.841418509,16.1298905 1.87929054,16.1298905 L7.99998344,16.1298905 L14.1207095,16.1298905 C15.1585484,16.1298905 16,15.3027795 16,14.2824828 C15.9999338,14.2824828 15.1813002,5.99682048 15.0274359,4.84740771 L15.0274359,4.84740771 Z M8.04591753,7.64554054 C8.06671538,7.61930062 8.0855924,7.59156313 8.1017869,7.56210019 C8.4607153,7.11289617 9.37125021,5.94541497 9.23897857,5.81603848 C9.13482376,5.71449715 8.33910752,6.12020671 7.76869022,6.43176509 C7.55504867,6.54844484 7.3728026,6.65200463 7.27066796,6.71070262 C7.24397519,6.72362725 7.21910388,6.73863544 7.19456375,6.7548482 C7.18946364,6.75777821 7.18174724,6.76230346 7.18174724,6.76230346 L7.18221089,6.7627918 C7.00413763,6.8859827 6.89405477,7.09443707 6.91432274,7.32330388 C6.92501972,7.44499722 6.97121875,7.55506815 7.0413618,7.64554054 L4.14473213,7.64554054 C4.07713914,7.64554054 4.02236265,7.59169336 4.02236265,7.5252471 C4.02236265,5.52499022 5.67774519,3.89765927 7.71252279,3.89765927 C7.81707501,3.89765927 7.92474029,3.90231474 8.03253803,3.91139779 C8.94949775,3.98884788 9.7994606,4.3991478 10.4257141,5.06663803 C11.05571,5.7380675 11.4026829,6.6112123 11.4026829,7.5252471 C11.4026829,7.59169336 11.3479065,7.64554054 11.2803135,7.64554054 L8.04591753,7.64554054 L8.04591753,7.64554054 Z",
      "id": "Shape",
      "stroke": "none",
      "fill": "#69A7D9",
      "fill-rule": "evenodd",
      "transform": "translate(8.000000, 9.564945) scale(-1, 1) translate(-8.000000, -9.564945) "
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.loading ? _vm.$t('message.loadingText') : _vm.title)
    }
  }), _vm._v(" "), (_vm.data.no_setting) ? _c('mu-flexbox-item', {
    class: {
      invisible: _vm.isOpenSetting || _vm.loading
    },
    attrs: {
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "icon": "settings"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSettings.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.data.no_setting) ? _c('mu-flexbox-item', {
    class: {
      invisible: _vm.isOpenSetting
    },
    attrs: {
      "align": "right"
    }
  }, [(!_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'add'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'remove'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isOpenSetting) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveSettings.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [(_vm.data.missing_settings.weight) ? _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "scroller": _vm.scroller,
      "data-vv-rules": "required",
      "data-vv-name": "weight_setting",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "Weight setting",
      "errorText": _vm.errors.first('weight_setting'),
      "label": _vm.$t('message.unitsPreferencesMeasureWeight'),
      "hintText": _vm.$t('message.selectText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.settings.weight),
      callback: function($$v) {
        _vm.$set(_vm.settings, "weight", $$v)
      },
      expression: "settings.weight"
    }
  }, _vm._l((_vm.data.missing_settings.weight), function(item, index) {
    return _c('mu-menu-item', {
      key: 'weight-setting-' + index,
      attrs: {
        "value": item.preference_id,
        "title": item.unit
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.data.missing_settings.height) ? _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "scroller": _vm.scroller,
      "data-vv-rules": "required",
      "data-vv-name": "height_setting",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('height_setting'),
      "label": _vm.$t('message.unitsPreferencesMeasureHeight'),
      "hintText": _vm.$t('message.selectText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.settings.height),
      callback: function($$v) {
        _vm.$set(_vm.settings, "height", $$v)
      },
      expression: "settings.height"
    }
  }, _vm._l((_vm.data.missing_settings.height), function(item, index) {
    return _c('mu-menu-item', {
      key: 'height-setting-' + index,
      attrs: {
        "value": item.preference_id,
        "title": item.unit
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.data.missing_settings.waist) ? _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "scroller": _vm.scroller,
      "data-vv-rules": "required",
      "data-vv-name": "waist_setting",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "Waist setting",
      "errorText": _vm.errors.first('waist_setting'),
      "label": _vm.$t('message.unitsPreferencesMeasureWaist'),
      "fullWidth": true,
      "hintText": _vm.$t('message.selectText')
    },
    model: {
      value: (_vm.settings.waist),
      callback: function($$v) {
        _vm.$set(_vm.settings, "waist", $$v)
      },
      expression: "settings.waist"
    }
  }, _vm._l((_vm.data.missing_settings.waist), function(item, index) {
    return _c('mu-menu-item', {
      key: 'waist-setting-' + index,
      attrs: {
        "value": item.preference_id,
        "title": item.unit
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), (_vm.isOpenSetting) ? _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeSettings.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? 'Saving' : 'Save'
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isOpenHeightSetting) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveHeightSettings.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('mu-row', [(_vm.height.measure === 'cm') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "272",
      "data-vv-rules": 'required|min_value:0|max_value:272',
      "data-vv-name": "height_cm",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "cm",
      "errorText": _vm.errors.first('height_cm'),
      "hintText": _vm.$t('message.placeholderText'),
      "label": "cm"
    },
    model: {
      value: (_vm.heightSettings.cm),
      callback: function($$v) {
        _vm.$set(_vm.heightSettings, "cm", _vm._n($$v))
      },
      expression: "heightSettings.cm"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.height.measure === 'ft-in') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "9",
      "data-vv-rules": 'required|min_value:0|max_value:9',
      "data-vv-name": "height_ft",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "ft",
      "errorText": _vm.errors.first('height_ft'),
      "hintText": _vm.$t('message.placeholderText'),
      "label": "ft",
      "fullWidth": true
    },
    model: {
      value: (_vm.heightSettings.ft),
      callback: function($$v) {
        _vm.$set(_vm.heightSettings, "ft", _vm._n($$v))
      },
      expression: "heightSettings.ft"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.height.measure === 'ft-in') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "11",
      "data-vv-rules": 'required|min_value:0|max_value:11',
      "data-vv-name": "height_in",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "in",
      "errorText": _vm.errors.first('height_in'),
      "hintText": _vm.$t('message.placeholderText'),
      "label": "in",
      "fullWidth": true
    },
    model: {
      value: (_vm.heightSettings.in),
      callback: function($$v) {
        _vm.$set(_vm.heightSettings, "in", _vm._n($$v))
      },
      expression: "heightSettings.in"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isOpenHeightSetting) ? _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": "Discard"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeHeightSettings.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? 'Saving' : 'Save'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveHeightSettings.apply(null, arguments)
      }
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.onToggleEnter,
      "leave": _vm.onToggleLeave
    }
  }, [(_vm.isOpenInput) ? _c('form', {
    staticStyle: {
      "overflow": "hidden"
    },
    style: ({
      height: _vm.computedAuto
    }),
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveReading.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('mu-row', [(_vm.weight.measure === 'kg') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "635",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:635',
      "data-vv-name": "kg",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "kg",
      "errorText": _vm.errors.first('kg'),
      "type": "number",
      "label": "KG",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.kg),
      callback: function($$v) {
        _vm.$set(_vm.model, "kg", _vm._n($$v))
      },
      expression: "model.kg"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.weight.measure === 'lbs') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "1400",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:1400',
      "data-vv-name": "lbs",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "lbs",
      "errorText": _vm.errors.first('lbs'),
      "type": "number",
      "label": "LBS",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.lbs),
      callback: function($$v) {
        _vm.$set(_vm.model, "lbs", _vm._n($$v))
      },
      expression: "model.lbs"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.weight.measure === 'st-lbs') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "min": "0",
      "max": "100",
      "data-vv-rules": 'required|min_value:0|max_value:100',
      "data-vv-name": "stones",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "st",
      "errorText": _vm.errors.first('stones'),
      "type": "number",
      "label": "ST",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.stones),
      callback: function($$v) {
        _vm.$set(_vm.model, "stones", _vm._n($$v))
      },
      expression: "model.stones"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.weight.measure === 'st-lbs') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "min": "0",
      "max": "13",
      "data-vv-rules": 'required|min_value:0|max_value:13',
      "data-vv-name": "pounds",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "lbs",
      "errorText": _vm.errors.first('pounds'),
      "type": "number",
      "label": "LBS",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.pounds),
      callback: function($$v) {
        _vm.$set(_vm.model, "pounds", _vm._n($$v))
      },
      expression: "model.pounds"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', [(!_vm.model.image) ? _c('image-uploader', {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      "title": _vm.$t('message.labelAddPhoto')
    },
    model: {
      value: (_vm.model.image),
      callback: function($$v) {
        _vm.$set(_vm.model, "image", $$v)
      },
      expression: "model.image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.model.image) ? _c('mu-card', {
    staticStyle: {
      "margin-bottom": "16px"
    }
  }, [_c('mu-card-text', [_c('mu-flat-button', {
    attrs: {
      "icon": "close",
      "label": "Clear image"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.removeImage.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), (_vm.model.image) ? _c('img', {
    staticStyle: {
      "margin-bottom": "-6px"
    },
    attrs: {
      "src": _vm.model.image,
      "width": "100%"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [(!_vm.isInputExpanded) ? _c('mu-raised-button', {
    attrs: {
      "label": _vm.$t('message.labelAdditionalInformation'),
      "icon": "expand_more"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleExpandedInput.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isInputExpanded) ? _c('mu-raised-button', {
    attrs: {
      "label": "Close",
      "icon": "expand_less"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleExpandedInput.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isInputExpanded) ? _c('mu-row', [_c('mu-col', {
    staticClass: "card-sub-header",
    staticStyle: {
      "margin-top": "16px"
    },
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('message.cardWeightWaistHipRatio')) + "\n          ")]), _vm._v(" "), (_vm.waist.measure == 'cm') ? _c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "305",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:305',
      "data-vv-name": "waist_cm",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "cm",
      "errorText": _vm.errors.first('waist_cm'),
      "hintText": _vm.$t('message.labelCMPlaceholder'),
      "label": _vm.$t('message.labelWaist'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.waist_cm),
      callback: function($$v) {
        _vm.$set(_vm.model, "waist_cm", _vm._n($$v))
      },
      expression: "model.waist_cm"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.waist.measure == 'cm') ? _c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "305",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:305',
      "data-vv-name": "hip_cm",
      "data-vv-as": "cm",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hip_cm'),
      "hintText": _vm.$t('message.labelCMPlaceholder'),
      "label": _vm.$t('message.labelHip'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.hip_cm),
      callback: function($$v) {
        _vm.$set(_vm.model, "hip_cm", _vm._n($$v))
      },
      expression: "model.hip_cm"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.waist.measure == 'in') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "120",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:120',
      "data-vv-name": "waist_in",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "in",
      "errorText": _vm.errors.first('waist_in'),
      "hintText": _vm.$t('message.labelInchesPlaceholder'),
      "label": _vm.$t('message.labelWaist'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.waist_in),
      callback: function($$v) {
        _vm.$set(_vm.model, "waist_in", _vm._n($$v))
      },
      expression: "model.waist_in"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.waist.measure == 'in') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "min": "0",
      "max": "120",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:120',
      "data-vv-name": "hip_in",
      "data-vv-as": "in",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hip_in'),
      "hintText": _vm.$t('message.labelInchesPlaceholder'),
      "label": _vm.$t('message.labelHip'),
      "fullWidth": true
    },
    model: {
      value: (_vm.model.hip_in),
      callback: function($$v) {
        _vm.$set(_vm.model, "hip_in", _vm._n($$v))
      },
      expression: "model.hip_in"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.labelCustomDate')
    },
    model: {
      value: (_vm.model.customDate),
      callback: function($$v) {
        _vm.$set(_vm.model, "customDate", $$v)
      },
      expression: "model.customDate"
    }
  }), _vm._v(" "), (_vm.model.customDate) ? _c('date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.model.date),
      callback: function($$v) {
        _vm.$set(_vm.model, "date", $$v)
      },
      expression: "model.date"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeInput.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveReading.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78dd2998","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/Input/Weight/Weight.vue
// module id = 3794
// module chunks = 1